import av1 from "../../../../assets/images/avatars/gc-baseball@2x.png";
import av2 from "../../../../assets/images/avatars/gc-blue-black@2x.png";
import av3 from "../../../../assets/images/avatars/gc-blue-white@2x.png";
import av4 from "../../../../assets/images/avatars/gc-gray-white@2x.png";
import av5 from "../../../../assets/images/avatars/gc-green-black@2x.png";
import av6 from "../../../../assets/images/avatars/gc-green-white@2x.png";
import av7 from "../../../../assets/images/avatars/gc-teal-white@2x.png";
import av8 from "../../../../assets/images/avatars/gc-white-black@2x.png";
import av9 from "../../../../assets/images/avatars/gc-white-green@2x.png";
import av10 from "../../../../assets/images/avatars/Masters1-1024x1024.png";
import av11 from "../../../../assets/images/avatars/Masters2-1024x1024.png";

export default [
  { src: av1, alt: "Gup's Corner Logo Baseball" },
  { src: av2, alt: "Gup's Corner Logo Blue and Black" },
  { src: av3, alt: "Gup's Corner Logo Blue and White" },
  { src: av4, alt: "Gup's Corner Logo Gray and White" },
  { src: av5, alt: "Gup's Corner Logo Green and Black" },
  { src: av6, alt: "Gup's Corner Logo Green and White" },
  { src: av7, alt: "Gup's Corner Logo Teal and White" },
  { src: av8, alt: "Gup's Corner Logo White and Black" },
  { src: av9, alt: "Gup's Corner Logo White and Green" },
  { src: av10, alt: "Gup's Corner Logo Masters Green Background" },
  { src: av11, alt: "Gup's Corner Logo Yellow Background" },
];
